import { Movies } from "./Types";

const initialState = { data: [], pageCount: 0 };
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Movies:
      return { data: action.data, pageCount: action.pages };
    //data is shared between all components
    // pageCount is shared between all components
    default: {
      return state;
    }
  }
};
